import {Backdrop, Drawer, ListItem, ListItemIcon} from '@mui/material';
import {LoginOutlined, LogoutOutlined} from '@mui/icons-material';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import MenuList from './MenuList';
import Tooltip from '../../Common/Tooltip';
import logo from '../../../assets/images/icon/logo.png';
import { CONSTANT } from '../../../constants/CONSTANT';
import Config from '../../../configs/config';

const Sidebar = ({roles, loading}) => {
  const { keycloak } = useKeycloak();
  const isLoggedIn = keycloak.authenticated;

  const brand = (
    <Tooltip title={`نسخه ${Config.appVersion || ''}`} placement="left">
      <div className="w-full flex items-center justify-center rounded-full p-1 cursor-pointer">
        <div className="relative w-full flex items-center justify-center bg-white rounded-full">
          <img src={logo} alt="logo" className="object-contain p-1" width={60} height={60}/>

          <Backdrop open={loading} className="absolute bg-white bg-opacity-60 rounded-full">
            <CircularProgress size={24}/>
          </Backdrop>
        </div>
      </div>
    </Tooltip>
  );

  return (
    <Drawer
      className="flex-shrink-0 overflow-hidden"
      variant="permanent"
      classes={{
        paper: 'w-menu h-full overflow-hidden ' +
            'bg-gradient-to-tr from-gray-800 via-gray-900 to-gray-900 ' +
            'hover:from-gray-700 hover:via-gray-800 hover:to-gray-900',
      }}
    >
      <div className="w-full h-full flex flex-col justify-between gap-4">
        <div className="w-full">
          {brand}
          {MenuList({ items: CONSTANT.SIDEBAR.MENU_ITEMS, roles})}
        </div>

        <div className="w-full flex flex-col justify-between gap-2 pb-4">
          {MenuList({ items: CONSTANT.SIDEBAR.MENU_FINAL, roles })}

          {!isLoggedIn ?
            <Tooltip title="ورود" placement="left" arrow>
              <ListItem button className="justify-center" disableGutters onClick={() => keycloak.login()}>
                <ListItemIcon className="w-full flex-row justify-center items-center text-gray-900">
                  <LoginOutlined className="text-gray-200"/>
                </ListItemIcon>
              </ListItem>
            </Tooltip>
              :
            <Tooltip title="خروج" placement="left" arrow>
              <ListItem button className="justify-center" disableGutters onClick={() => keycloak.logout()}>
                <ListItemIcon className="w-full flex-row justify-center items-center text-gray-900">
                  <LogoutOutlined className="text-gray-200"/>
                </ListItemIcon>
              </ListItem>
            </Tooltip>
          }

        </div>
      </div>
    </Drawer>
  );
};

Sidebar.defaultProps = {
  roles: null,
  loading: false,
};

Sidebar.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
};

export default Sidebar;
